<template>
    <div class="agreement-page">
        <nav-bar title="提现协议签署" url="/balance"></nav-bar>
        <div class="top">
            <div class="title"><div class="title-text">年卡推广结算协议2026</div></div>
            <div class="agreement-copy">本人确认已阅读并同意崆峒山年卡推广结算协议，提现申请提交后由后台审核，审核通过后加盖甲方公章。<br><a :href="templateUrl" target="_blank">查看协议全文 PDF</a></div>
            <van-cell title="乙方签署日期" :value="today"></van-cell>
            <van-field v-model="invoiceAmount" type="number" label="凭证金额" placeholder="请输入发票或凭证金额"></van-field>
            <van-cell title="上传发票/收款凭证">
                <van-uploader :after-read="uploadInvoice" :before-read="beforeInvoiceRead" accept="image/*,.pdf" :disabled="uploading">
                    <van-button size="small" plain type="primary" :loading="uploading">{{ uploading ? '上传中' : '选择文件' }}</van-button>
                </van-uploader>
            </van-cell>
            <van-cell v-if="invoiceUrl" title="凭证状态" value="已上传"/>
        </div>
        <div class="top sign-box">
            <div class="title"><div class="title-text">手写签名</div></div>
            <div v-if="signature" class="signed-tip">已签署，可直接提交提现</div>
            <canvas ref="canvas" width="700" height="260" @mousedown="start" @mousemove="move" @mouseup="end" @mouseleave="end" @touchstart.prevent="start" @touchmove.prevent="move" @touchend.prevent="end"></canvas>
            <van-button size="small" plain @click="clear">清除签名</van-button>
        </div>
        <div class="action"><van-button type="primary" :color="config.main_color" size="large" round :loading="loading" :disabled="loading" @click="submit">确认签署并提交提现</van-button></div>
    </div>
</template>

<script>
import {sale_info, sale_withdraw_submit} from '@/api/sale.js';
import {common_image} from '@/api/common.js';
import {Toast, Dialog} from 'vant';

const AGREEMENT_VERSION = '年卡推广结算协议2026';

export default {
    name: 'sale_agreement',
    computed: {
        templateUrl() {
            return this.config.api_url.replace(/wechat2\/?$/, '') + '/data/withdraw_agreement/协议模板2026.pdf';
        },
        draftKey() {
            return this.info.id ? 'nianka_withdraw_agreement_' + this.info.id : '';
        },
    },
    data() {
        return {
            info: {},
            money: '',
            invoiceAmount: '',
            invoiceUrl: '',
            signature: '',
            drawing: false,
            loading: false,
            uploading: false,
            today: new Date().toISOString().slice(0, 10),
        };
    },
    mounted() {
        this.money = this.$route.query.money || '';
        const canvas = this.$refs.canvas;
        const context = canvas.getContext('2d');
        context.lineWidth = 5;
        context.lineCap = 'round';
        context.strokeStyle = '#222';
        sale_info({}).then(res => {
            if (res && res.code === 1) {
                this.info = res.data;
                this.restoreDraft();
            }
        });
    },
    methods: {
        point(e) {
            const rect = this.$refs.canvas.getBoundingClientRect();
            const point = e.touches ? e.touches[0] : e;
            return {
                x: (point.clientX - rect.left) * 700 / rect.width,
                y: (point.clientY - rect.top) * 260 / rect.height,
            };
        },
        start(e) {
            this.drawing = true;
            const point = this.point(e);
            const context = this.$refs.canvas.getContext('2d');
            context.beginPath();
            context.moveTo(point.x, point.y);
        },
        move(e) {
            if (!this.drawing) return;
            const point = this.point(e);
            const context = this.$refs.canvas.getContext('2d');
            context.lineTo(point.x, point.y);
            context.stroke();
        },
        end() {
            if (this.drawing) {
                this.signature = this.$refs.canvas.toDataURL('image/png');
                this.persistDraft();
            }
            this.drawing = false;
        },
        clear() {
            this.$refs.canvas.getContext('2d').clearRect(0, 0, 700, 260);
            this.signature = '';
            this.persistDraft();
        },
        restoreDraft() {
            if (!this.draftKey) return;
            try {
                const draft = JSON.parse(localStorage.getItem(this.draftKey) || 'null');
                if (!draft) return;
                this.signature = draft.signature || '';
                this.invoiceUrl = draft.invoiceUrl || '';
                this.invoiceAmount = draft.invoiceAmount || '';
                if (!this.signature) return;
                const image = new Image();
                image.onload = () => {
                    this.$refs.canvas.getContext('2d').drawImage(image, 0, 0, 700, 260);
                };
                image.src = this.signature;
            } catch (e) {
                localStorage.removeItem(this.draftKey);
            }
        },
        persistDraft() {
            if (!this.draftKey) return;
            localStorage.setItem(this.draftKey, JSON.stringify({
                signature: this.signature,
                invoiceUrl: this.invoiceUrl,
                invoiceAmount: this.invoiceAmount,
                version: AGREEMENT_VERSION,
            }));
        },
        clearDraft() {
            if (this.draftKey) localStorage.removeItem(this.draftKey);
        },
        beforeInvoiceRead(file) {
            const item = Array.isArray(file) ? file[0] : file;
            if (!item || (!/^image\//.test(item.type || '') && item.type !== 'application/pdf')) {
                Toast('请选择图片或PDF文件');
                return false;
            }
            return true;
        },
        uploadInvoice(file) {
            const raw = file && file.file;
            if (!raw) {
                Toast.fail('未读取到文件，请重新选择');
                return;
            }
            this.uploading = true;
            Toast.loading({duration: 0, forbidClick: true, message: '上传中……'});
            const form = new FormData();
            form.append('file', raw, raw.name || 'invoice.jpg');
            common_image(form).then(res => {
                const url = res && res.code === 1 ? (typeof res.data === 'string' ? res.data : res.data && res.data.url) : '';
                if (!url) throw new Error((res && res.msg) || '上传失败');
                this.invoiceUrl = url;
                this.persistDraft();
                Toast.clear();
                Toast.success('上传成功');
            }).catch(error => {
                console.error('invoice upload failed', error);
                this.invoiceUrl = '';
                Toast.clear();
                Toast.fail(error.message || '上传失败，请重试');
            }).then(() => {
                this.uploading = false;
            });
        },
        submit() {
            if (this.uploading) return Toast('发票正在上传，请稍候');
            if (this.info.sale_cert_state != 1) return Dialog.alert({title: '提示', message: '请先完成实名认证'}).then(() => this.$router.push('/cert'));
            if (!this.signature) return Toast('请完成手写签名');
            if (!this.invoiceUrl) return Toast('请上传发票或收款凭证');
            if (!this.money) return Toast('提现金额不能为空');
            this.loading = true;
            sale_withdraw_submit({
                id: this.info.id,
                money: this.money,
                agreement_version: AGREEMENT_VERSION,
                agreement_signature: this.signature,
                invoice_url: this.invoiceUrl,
                invoice_amount: this.invoiceAmount,
                loading: true,
                loading_text: '提交中……',
            }).then(res => {
                if (res && res.code === 1) {
                    this.clearDraft();
                    Dialog.alert({title: '提示', message: res.msg || '提现申请已提交'}).then(() => this.$router.replace('/sale_withdraw_detail?id=' + res.data));
                }
            }).catch(error => {
                console.error('withdraw submit failed', error);
                Toast.fail('提交失败，请稍后直接重试');
            }).then(() => {
                this.loading = false;
            });
        },
    },
};
</script>

<style scoped>
.agreement-page{min-height:100vh;background:#f7f8fa;padding-bottom:20px}
.top{width:calc(100% - 40px);margin:20px auto;background:#fff;border-radius:10px;overflow:hidden}
.title{height:40px;line-height:40px;color:#fff;background:var(--main-color);padding-left:20px}
.agreement-copy{padding:18px;line-height:1.8;color:#555}
.sign-box{padding-bottom:12px}
.sign-box canvas{display:block;width:calc(100% - 24px);height:180px;margin:12px;border:1px dashed #bbb;background:#fff}
.sign-box .van-button{margin-left:12px}
.signed-tip{padding:10px 12px 0;color:#038866;font-size:13px}
.action{margin:20px}
</style>
